"use strict";

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DatasetContext =
/*#__PURE__*/
function () {
  function DatasetContext(dataset) {
    _classCallCheck(this, DatasetContext);

    this.dataset = dataset;
    this.fields = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = dataset.tables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var table = _step.value;
        this.fields[table.name] = table.rows;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  _createClass(DatasetContext, [{
    key: "getTableContext",
    value: function getTableContext(table) {
      return new TableContext(this, table);
    }
  }, {
    key: "getVariable",
    value: function getVariable(name) {
      return this.fields[name];
    }
  }]);

  return DatasetContext;
}();

exports.DatasetContext = DatasetContext;

var TableContext =
/*#__PURE__*/
function () {
  function TableContext(parent, table) {
    _classCallCheck(this, TableContext);

    this.parent = parent;
    this.table = table;
    this.fields = {};
    this.fields.table = table.rows;
  }

  _createClass(TableContext, [{
    key: "getRowContext",
    value: function getRowContext(row) {
      return new RowContext(this, row);
    }
  }, {
    key: "getVariable",
    value: function getVariable(name) {
      var r = this.fields[name];

      if (r === undefined) {
        return this.parent.getVariable(name);
      }
    }
  }]);

  return TableContext;
}();

exports.TableContext = TableContext;

var RowContext =
/*#__PURE__*/
function () {
  function RowContext(parent, row) {
    _classCallCheck(this, RowContext);

    this.parent = parent;
    this.row = row;
  }

  _createClass(RowContext, [{
    key: "getVariable",
    value: function getVariable(name) {
      var r = this.row[name];

      if (r === undefined) {
        return this.parent.getVariable(name);
      } else {
        return r;
      }
    }
  }]);

  return RowContext;
}();

exports.RowContext = RowContext;